<template>
    <v-card class="overflow-hidden">
        <v-app-bar id="menu" app dense flat tile elevation="0" color="#fff" class="menu-border" height="48px">
            <AppMenuNav :items="navMenuGuestItems"></AppMenuNav>

            <v-app-bar-nav-icon class="hidden-lg-and-up ml-n3 ml-md-0" @click="mobileMenuDrawer = true" style="color: #6aa84f"></v-app-bar-nav-icon>

            <div style="width: 55%; display: flex; justify-content: right">
                <v-icon small>mdi-alert-circle-outline</v-icon>
                {{ $t('guest.oddsDelayed') }}
            </div>

            <v-spacer></v-spacer>

<!--            <AppMenuBreadcrumbs></AppMenuBreadcrumbs>-->

            <v-divider :class="[$vuetify.breakpoint.width < 524 ? 'd-none d-sm-flex' : '']" inset vertical></v-divider>

            <AppMenuDarkSwitcher></AppMenuDarkSwitcher>

            <v-menu offset-y v-model="userMenu" :close-on-content-click="false" :nudge-width="200" offset-x>
                <template v-slot:activator="{ on: activationEvents }">
                    <v-tooltip :disabled="utils.isMobile()" :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'" open-delay="500" bottom>
                        <template v-slot:activator="{ on }">
                            <span v-on="on">
                                <v-btn
                                    tag="a"
                                    class="link-menu"
                                    :height="$vuetify.breakpoint.xs ? 30 : 46"
                                    min-width="30"
                                    :width="$vuetify.breakpoint.xs ? 30 : 50"
                                    text
                                    v-on="activationEvents"
                                >
                                    <v-icon :color="$vuetify.theme.dark ? '' : '#867878'">mdi-account-box-outline</v-icon>
                                </v-btn>
                            </span>
                        </template>
                        <span class="menuable__content__active-enter-active">
                            {{ $t('menu.account') }}
                        </span>
                    </v-tooltip>
                </template>

                <v-card v-if="user" width="350px">
                    <AppMenuAccountChangeLocaleAndTimeZone></AppMenuAccountChangeLocaleAndTimeZone>
                </v-card>
            </v-menu>

            <AppMenuHelp :items="navMenuSupportItems"></AppMenuHelp>

<!--            <v-tooltip :disabled="utils.isMobile()" :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'" open-delay="500" bottom v-if="$i18n.locale === 'pt'">-->
<!--                <template v-slot:activator="{ on }">-->
<!--                    <span v-on="on">-->
<!--                        <v-btn-->
<!--                            tag="a"-->
<!--                            href="https://www.youtube.com/@Tradeball"-->
<!--                            target="_blank"-->
<!--                            class="link-menu"-->
<!--                            :height="$vuetify.breakpoint.xs ? 30 : 46"-->
<!--                            min-width="30"-->
<!--                            :width="$vuetify.breakpoint.xs ? 30 : 50"-->
<!--                            text-->
<!--                            v-on="activationEvents"-->
<!--                        >-->
<!--                            <v-icon :color="$vuetify.theme.dark ? '' : '#867878'">mdi-youtube</v-icon>-->
<!--                        </v-btn>-->
<!--                    </span>-->
<!--                </template>-->
<!--                <span class="menuable__content__active-enter-active">-->
<!--                    {{ $t('menu.videoGuide') }}-->
<!--                </span>-->
<!--            </v-tooltip>-->
        </v-app-bar>
        <!--        <AppMenuMobile :items="navMenuGuestItems"></AppMenuMobile>-->
    </v-card>
</template>
<style scoped>
    .theme--dark {
        background-color: #1e1f22 !important;
        color: white !important;
    }
</style>
<script>
    import { mapGetters, mapState } from 'vuex';
    import utils from '../../helpers/utils';
    import AppMenuAccountChangeLocaleAndTimeZone from './AppMenuAccountChangeLocaleAndTimeZone';
    import AppMenuDarkSwitcher from './AppMenuDarkSwitcher';
    import AppMenuBreadcrumbs from './AppMenuBreadcrumbs';
    import AppMenuNav from './AppMenuNav';
    import AppMenuMobile from './AppMenuMobile';
    import AppMenuHelp from 'Components/menu/AppMenuHelp.vue';

    export default {
        name: 'app-menu-guest',
        components: {
            AppMenuHelp,
            AppMenuDarkSwitcher,
            AppMenuNav,
            AppMenuBreadcrumbs,
            AppMenuAccountChangeLocaleAndTimeZone,
            AppMenuMobile,
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },
        mounted() {
            this.requiredDictionaries = ['TimeZone'];
        },
        data() {
            return {
                selection: [],
            };
        },
        mixins: [utils],
        methods: {
            clear() {
                this.selection = [];
            },
        },
        computed: {
            ...mapGetters({
                getTimeZone: 'DictionariesModule/getTimeZone',
            }),
            ...mapState({
                config: (state) => state.AppModule.config,
            }),
            breadcrumbs: {
                get() {
                    return this.$store.getters['MenuModule/getBreadcrumbs'];
                },
            },
            toolUserSettings: {
                get() {
                    return this.$store.getters['AppModule/getToolUserSettings'];
                },
                set(value) {
                    this.$store.commit('AppModule/setToolUserSettings', value);
                },
            },
            navMenuGuestItems: {
                get() {
                    return this.$store.getters['MenuModule/getNavMenuGuestItems'];
                },
            },

            mobileMenuDrawer: {
                get() {
                    return this.$store.getters['MenuModule/getMobileMenuDrawer'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setMobileMenuDrawer', value);
                },
            },
            requiredDictionaries: {
                get() {
                    return this.$store.getters['PageModule/getRequiredDictionaries'];
                },
                set(value) {
                    this.$store.commit('PageModule/setRequiredDictionaries', value);
                },
            },
            userMenu: {
                get() {
                    return this.$store.getters['MenuModule/getUserMenu'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setUserMenu', value);
                },
            },
            user() {
                return this.$store.getters['UserModule/getUser'];
            },
            navMenuSupportItems: {
                get() {
                    return this.$store.getters['MenuModule/getNavMenuWLSupportItems'];
                },
            },
        },
    };
</script>
